import { useEffect, useState, Fragment } from 'react';
import { Typography, Grid, Button, Stack, Snackbar, Alert, Box } from '@mui/material';
import { Breadcrumb } from 'components';
import { ButtonAlign, ButtonAlignLeft, RightAlignButton } from '../../home/Home-components';
import { ApprovalDialog } from '../module/StandardQuote/InnerComponent';
import {
    getQuotesList,
    getAssociateFeeList,
    getAnalysisList,
    getResultTableNames,
    getResultTableData,
    getContacts,
    getClientOnboardingStates,
    getASMUser,
    userData
} from 'services';
import { useSearchParams, useNavigate } from 'react-router';
import moment from 'moment';
import { PriceTable } from '../components/PriceTable';
import { Input } from '../components/Input';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import TaskOutlinedIcon from '@mui/icons-material/TaskOutlined';
import SingleRowExpand from '../module/StandardQuote/AnalysisGrid/SingleRowExpand';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

let projectDetails: any = [];
let associateFeeList: any = [];
let priceTableResult: any = [];

const DetailRow = ({
    label,
    children,
}: {
    label: string;
    children: React.ReactNode;
}) => (
    <Grid container spacing={1} alignItems="flex-start">
        <Grid item xs={4}>
            <Typography variant="body2" fontWeight={600}>
                {label}
            </Typography>
        </Grid>

        <Grid item xs={8}>
            {typeof children === "string" ? (
                <Typography variant="body2">{children}</Typography>
            ) : (
                children
            )}
        </Grid>
    </Grid>
);

const FeeRow = ({ label, children }: { label: string; children: React.ReactNode }) => (
    <Grid container spacing={2} sx={{ mb: 2 }}>
        <Grid item xs={12} sm={4} md={4}>
            <Typography variant="body2" fontWeight={600}>
                {label}
            </Typography>
        </Grid>
        <Grid item xs={12} sm={8} md={8}>
            {children}
        </Grid>
    </Grid>
);

export const ReviewQuote = () => {
    const [isApprovalDialog, setIsApprovalDialog] = useState(false);
    const [analysisList, setAnalysisList] = useState([] as any[]);
    const [resultTableNames, setResultTableNames] = useState([] as any[]);
    const [resultTableData, setResultTableData] = useState([] as any[]);
    const [reportStateList, setReportStateList] = useState([] as any[]);
    const [asmUser, setAsmUser] = useState([] as any[]);
    const [userInfo, setUserInfo] = useState(null);
    const [contactName, setContactName] = useState('');
    const [error, setError] = useState(false);
    const [errorMessage, setErrorMessage] = useState();
    const [searchparams] = useSearchParams();
    const navigate = useNavigate();

    useEffect(() => {
        let paramId = searchparams.get('id');
        if (paramId !== null) {
            getQuotesList(paramId).then((res: any) => {
                if (res.status === 200) {
                    projectDetails = res?.data;
                }
            });

            getAssociateFeeList(paramId).then((res: any) => {
                if (res.status === 200) {
                    associateFeeList = res?.data;
                }
            });

            getAnalysisList(paramId).then((res: any) => {
                if (res.status === 200) {
                    setAnalysisList(res?.data);
                }
            });

            getResultTableNames(paramId).then((res: any) => {
                if (res.status === 200) {
                    setResultTableNames(res?.data);
                }
            });

            getResultTableData(paramId).then((res: any) => {
                if (res.status === 200) {
                    loadPriceTable();
                    setResultTableData(res?.data);
                }
            });
            getClientOnboardingStates().then((res: any) => {
                if (res.status === 200) {
                    setReportStateList(res?.data);
                }
            });
            getASMUser().then((res: any) => {
                if (res.status === 200) {
                    setAsmUser(res?.data.users);
                }
            });
            userData(0).then((res: any) => {
                setUserInfo(res.data);
            })
        }
    }, [])

    useEffect(() => {
        if (projectDetails?.clientID) {
            getContacts(projectDetails?.clientID).then((res: any) => {
                if (res.status === 200) {
                    res.data.map((i: any) => {
                        if (projectDetails.addressTo === i.id) {
                            setContactName(i.name);
                        }
                    })
                } else {
                    setError(true);
                    setErrorMessage(res?.data);
                }
            })
        }
    }, [projectDetails])

    const handleApprovalDialog = () => {
        setIsApprovalDialog(true);
    }

    const getStateName = (id: number | string) => {
        const state = reportStateList.find(
            (item: any) => String(item.id) === String(id)
        );

        return state ? state.name : "-";
    };

    const quotesContactInfo = projectDetails?.quotesContactInfo;
    const hasQuotesContactInfo = !!(
        quotesContactInfo?.name ||
        quotesContactInfo?.email ||
        quotesContactInfo?.phone ||
        quotesContactInfo?.mobile
    );

    let nav: any = [{ name: 'Home', path: '/home/viewQuote' }, { name: 'Quote', path: '/home/viewQuote' }, { name: 'Review Quote', path: '/home/reviewQuote' }];

    const loadPriceTable = () => {
        return (
            resultTableNames && resultTableNames.map((el: any, index: any) => {
                return (
                    <Fragment key={index}>
                        <Box
                            sx={{
                                display: 'flex',
                                gap: '10px',
                                alignItems: 'center',
                            }}
                        >
                            <Input
                                placeholder={el.name}
                                value={el.name}
                                variant="filled"
                                size="small"
                                disabled
                                sx={{
                                    marginBottom: '10px',
                                    '&:before': {
                                        borderBottom: 'none'
                                    },
                                    '.MuiFilledInput-root .MuiInputBase-input': {
                                        fontSize: '12px',
                                        fontWeight: '600'
                                    },
                                    pointerEvents: 'none',
                                }}
                                required
                            />
                            <Input
                                placeholder={el.reference}
                                value={el.reference}
                                variant="filled"
                                size="small"
                                disabled
                                sx={{
                                    marginBottom: '10px',
                                    '&:before': {
                                        borderBottom: 'none'
                                    },
                                    '.MuiFilledInput-root .MuiInputBase-input': {
                                        fontSize: '12px',
                                        fontWeight: '600'
                                    },
                                    pointerEvents: 'none',
                                }}
                                required
                            />
                            <Input
                                placeholder={el.sampleNumberReference}
                                value={el.sampleNumberReference}
                                variant="filled"
                                size="small"
                                disabled
                                sx={{
                                    marginBottom: '10px',
                                    '&:before': {
                                        borderBottom: 'none'
                                    },
                                    '.MuiFilledInput-root .MuiInputBase-input': {
                                        fontSize: '12px',
                                        fontWeight: '600'
                                    },
                                    pointerEvents: 'none',
                                }}
                                required
                            />
                        </Box>
                        <PriceTable
                            result={resultTableData}
                            id={el.id}
                            status='view'
                        />
                        <br />
                    </Fragment>
                )
            }
            )
        )
    }

    let clientName = projectDetails.clientInfo ? `${projectDetails.clientInfo.name} - ${projectDetails.clientInfo.code}` : null;

    return (
        <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', padding: '16px 0', cursor: 'pointer' }}>
                <Breadcrumb navList={nav} />
            </div>
            <Typography variant="h6" gutterBottom align='left' mt={1} color="secondary.main">
                Review Quote
            </Typography>
            <RightAlignButton>
                <Typography variant="h6" gutterBottom align='right' mt={2} mr={3} color="secondary.main">
                    Quote Number: {projectDetails.quoteNumber}
                </Typography>
            </RightAlignButton>
            <Typography variant="h6" gutterBottom mt={1} pb={3} color="secondary.main">
                Client and Project Details
            </Typography>
            <Grid container spacing={3}>
                {projectDetails?.clientID !== -1 && (
                    <Grid item xs={12} md={4}>
                        <DetailRow label="Client Name">
                            {clientName}
                        </DetailRow>
                    </Grid>
                )}

                <Grid item xs={12} md={4}>
                    <DetailRow label="Price List Name">
                        {projectDetails.priceListName}
                    </DetailRow>
                </Grid>

                <Grid item xs={12} md={4}>
                    <DetailRow label="Project Name">
                        {projectDetails.projectName || "-"}
                    </DetailRow>
                </Grid>

                <Grid item xs={12} md={4}>
                    <DetailRow label="Project Start Date">
                        {moment(projectDetails.projectStartDate).format("DD/MM/YYYY")}
                    </DetailRow>
                </Grid>

                <Grid item xs={12} md={4}>
                    <DetailRow label="Quote Valid To">
                        {moment(projectDetails.projectValidTo).format("DD/MM/YYYY")}
                    </DetailRow>
                </Grid>

                <Grid item xs={12} md={4}>
                    <DetailRow label="Attention To">
                        <>
                            <Typography variant="body2">
                                {projectDetails?.clientID === -1
                                    ? projectDetails.addressToName
                                    : contactName}
                            </Typography>

                            {hasQuotesContactInfo && (
                                <Box mt={1}>
                                    <Typography variant="body2">
                                        <strong>Name:</strong> {quotesContactInfo?.name || "-"}
                                    </Typography>

                                    {quotesContactInfo?.email && (
                                        <Typography variant="body2">
                                            <strong>Email:</strong> {quotesContactInfo.email}
                                        </Typography>
                                    )}

                                    {quotesContactInfo?.phone && (
                                        <Typography variant="body2">
                                            <strong>Phone:</strong> {quotesContactInfo.phone}
                                        </Typography>
                                    )}

                                    {quotesContactInfo?.mobile && (
                                        <Typography variant="body2">
                                            <strong>Mobile:</strong> {quotesContactInfo.mobile}
                                        </Typography>
                                    )}
                                </Box>
                            )}
                        </>
                    </DetailRow>
                </Grid>

                {projectDetails?.clientID === -1 && (
                    <>
                        <Grid item xs={12} md={4}>
                            <DetailRow label="Deliver To Email">
                                {projectDetails.deliverToEmail}
                            </DetailRow>
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <DetailRow label="Client Name ">
                                {projectDetails.newClientName}
                            </DetailRow>
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <DetailRow label="State">
                                {getStateName(projectDetails.stateID)}
                            </DetailRow>
                        </Grid>
                    </>
                )}

                <Grid item xs={12} md={4}>
                    <DetailRow label="Service Contact">
                        {projectDetails.serviceContact ? (
                            <Box>
                                <Typography variant="body2">
                                    <strong>Name:</strong> {projectDetails.serviceContact.name}
                                </Typography>
                                <Typography variant="body2">
                                    <strong>Email:</strong> {projectDetails.serviceContact.email}
                                </Typography>
                                <Typography variant="body2">
                                    <strong>Phone:</strong> {projectDetails.serviceContact.phoneNo}
                                </Typography>
                            </Box>
                        ) : (
                            <Typography variant="body2">Client Manager</Typography>
                        )}
                    </DetailRow>
                </Grid>

                <Grid item xs={12} md={4}>
                    <DetailRow label="Signature Contact">
                        {projectDetails.signatureUserID ? (
                            <Box>
                                <Typography variant="body2">
                                    {(() => {
                                        const asmUserDetails = asmUser?.find(
                                            user => user?.id === projectDetails?.signatureUserID
                                        );

                                        return asmUserDetails
                                            ? `${asmUserDetails?.firstname} ${asmUserDetails?.lastname}` : "";

                                    })()}
                                </Typography>
                            </Box>
                        ) : null}
                    </DetailRow>
                </Grid>


                <Grid item xs={12} md={4}>
                    <DetailRow label="Description">
                        {projectDetails.description || "-"}
                    </DetailRow>
                </Grid>
            </Grid>
            <Typography variant="h6" gutterBottom mt={4} pb={2} color="secondary.main">
                Associated Fees
            </Typography>
            <Grid container spacing={2}>

                <Grid item xs={12}>
                    <FeeRow label="Handling Charge :">
                        <Typography variant="subtitle1">
                            {associateFeeList.hasHandlingCharge
                                ? associateFeeList.handlingCharge
                                : "NA"}
                        </Typography>
                    </FeeRow>
                </Grid>

                <Grid item xs={12}>
                    <FeeRow label="Courier Charges to Eurofins Lab/Office :">
                        {associateFeeList.hasCourierChargeToLab ? (
                            associateFeeList.courierCharges.map((item: any, index: number) => (
                                <Grid container spacing={2} key={index} sx={{ mb: 1 }}>
                                    <Grid item xs={12} sm={4}>
                                        <Typography variant="subtitle1">
                                            <b>From Location :</b> {item.fromLocation}
                                        </Typography>
                                    </Grid>

                                    <Grid item xs={12} sm={4}>
                                        <Typography variant="subtitle1">
                                            <b>To Location :</b> {item.toLocationName}
                                        </Typography>
                                    </Grid>

                                    <Grid item xs={12} sm={4}>
                                        <Typography variant="subtitle1">
                                            <b>Amount :</b> {item.amount}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            ))
                        ) : (
                            <Typography variant="subtitle1">
                                NA
                            </Typography>
                        )}
                    </FeeRow>
                </Grid>

                <Grid item xs={12}>
                    <FeeRow label="Courier Charges for Sampling Containers :">
                        {associateFeeList.hasCourierChargeForContainer ? (
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={4}>
                                    <Typography variant="subtitle1">
                                        <b>From Location :</b> {associateFeeList.cccFromLabName}
                                    </Typography>
                                </Grid>

                                <Grid item xs={12} sm={4}>
                                    <Typography variant="subtitle1">
                                        <b>To Location :</b> {associateFeeList.cccToLab}
                                    </Typography>
                                </Grid>

                                <Grid item xs={12} sm={4}>
                                    <Typography variant="subtitle1">
                                        <b>Amount :</b> {associateFeeList.courierChargeForContainer}
                                    </Typography>
                                </Grid>
                            </Grid>
                        ) : (
                            <Typography variant="subtitle1">
                                NA
                            </Typography>
                        )}
                    </FeeRow>
                </Grid>

                <Grid item xs={12}>
                    <FeeRow label="Split Courier Charge :">
                        <Typography variant="subtitle1">
                            {associateFeeList.hasSplitCourierCharge
                                ? associateFeeList.splitCourierCharge
                                : "NA"}
                        </Typography>
                    </FeeRow>
                </Grid>

            </Grid>
            <Typography variant="h6" gutterBottom mt={3} pb={3} color="secondary.main">
                Analysis Fees / Test Specification
            </Typography>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={12} md={12} style={{ paddingTop: 0 }}>
                    <SingleRowExpand
                        data={analysisList}
                        pageName="view"
                    />
                </Grid>
            </Grid>
            {resultTableNames.length > 0 ? <Typography variant="h6" gutterBottom mt={4} pb={2} color="secondary.main">
                Result Table
            </Typography> : null}
            {priceTableResult ? loadPriceTable() : null}
            <Box sx={{ display: 'flex', justifyContent: 'space-between', marginTop: 2 }}>
                <ButtonAlignLeft>
                    <Button
                        variant="outlined"
                        color="primary"
                        style={{ marginRight: '10px' }}
                        onClick={() => navigate('/home/viewQuote')}
                        startIcon={<ArrowBackIcon />}
                        tabIndex={-1}
                    >
                        Back
                    </Button>
                </ButtonAlignLeft>
                <ButtonAlign>
                    <Button
                        variant="outlined"
                        color="primary"
                        style={{ marginRight: '10px' }}
                        onClick={handleApprovalDialog}
                        disabled
                        startIcon={<TaskOutlinedIcon />}
                        tabIndex={-1}
                    >
                        Approved / Rejected
                    </Button>
                    <Button
                        variant="contained"
                        disabled
                        startIcon={<SaveOutlinedIcon />}
                        tabIndex={-1}
                        color="primary"
                    >
                        Save
                    </Button>
                </ButtonAlign>
            </Box>
            <ApprovalDialog
                open={isApprovalDialog}
                onClose={() => setIsApprovalDialog(false)}
            />
            <Stack sx={{ width: '100%', marginTop: 2 }} spacing={2}>
                <Snackbar open={error} autoHideDuration={6000} onClose={() => setError(false)}>
                    <Alert onClose={() => setError(false)} severity="warning"> {errorMessage}</Alert>
                </Snackbar>
            </Stack>
        </div >
    );
}
